import { Controller, Application } from '@hotwired/stimulus';

export class ProductItemOwnedController extends Controller {
    static targets = ['favoriteToggle'];

    favoriteToggleTarget: HTMLButtonElement;

    connect() {}

    toggleFavorite(event) {
        const { toggleUrl } = event.params;
        const currentState = this.getFavoriteState();
        this.setFavoriteState(!currentState, toggleUrl);
    }

    getFavoriteState() {
        return this.favoriteToggleTarget.getAttribute('aria-pressed') === 'true';
    }

    async setFavoriteState(newState: boolean, toggleUrl?: string) {
        this.favoriteToggleTarget.setAttribute('aria-pressed', newState.toString());

        if (toggleUrl) {
            try {
                const response = await fetch(toggleUrl, {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                });

                const data = await response.json();

                if (response.status >= 400) {
                    if (response.status >= 400) {
                        const error = new Error('Error from API. URL: ' + toggleUrl);
                        (error as any).userMessage = data.error;
                        throw error;
                    }
                } else {
                    const favorite = data.isFavorited !== undefined ? data.isFavorited : data.user?.favorite;
                    if (favorite !== undefined) {
                        this.favoriteToggleTarget.setAttribute('aria-pressed', favorite.toString());
                    }

                    const toggleUrl = data.toggleUrl || data.user?.actions?.favorite?.action || null;
                    if (toggleUrl) {
                        this.favoriteToggleTarget.setAttribute('data-product-item-owned-toggle-url-param', toggleUrl);
                    }
                }
            } catch (e) {
                // Undo
                this.favoriteToggleTarget.setAttribute('aria-pressed', (!newState).toString());
            }
        }
    }

    static register(application: Application) {
        application.register('product-item-owned', this);
    }
}
